import { AccountLinkResponseDto, INTEGRATION_CODE } from "../../../../../../models/IntegrationsTypes";
import IntegrationsService from "../../../../../../services/api/integrations-service";
import { TYPE, rootContainer } from "../../../../../../services/container/root";

interface IEventMessage {
    type: string;
    [payloadKey: string]: any;
}


class IntegratorOAuthHandler {
    private _integrationCode: INTEGRATION_CODE;
    
    private _window = {} as Window;
    private _intervalId: any = undefined;
    private _messageHandler?: (event: IEventMessage) => void;
    private _closeInterval = 50;
    
    private get integrationsService(): IntegrationsService {
        return rootContainer.get<IntegrationsService>(TYPE.IntegrationsService);
    }
    
    constructor(integrationCode: INTEGRATION_CODE) {
        this._integrationCode = integrationCode;
    }

    public async getCredentials(inputData?: Record<string, any>, isSandbox?: boolean) {

        if (this._messageHandler) {
            window.removeEventListener('message', this._messageHandler, false);
        }

        return new Promise(async (resolve, reject) => {
            let linkResponse: AccountLinkResponseDto;
            /** when we need to request the window popup url from server (integrator) */
            try {
                linkResponse = await this.integrationsService.createAccountLink(this._integrationCode, inputData, isSandbox);
            }
            catch (err) {
                reject(err);
                return;
            }

            this._window = window.open(linkResponse.authLink, '', 'width=800,height=600,resizeable,scrollbars') as Window;

            this._messageHandler = (event: IEventMessage) => {
                this._handleMessage(event, resolve, linkResponse, inputData);
            };

            window.addEventListener('message', this._messageHandler, false);

            this._listenToWindowClosed(reject);
        });
    }

    private _listenToWindowClosed(reject: (reason?: any) => void) {
        /** make sure to always clear interval before starting new one */
        clearInterval(this._intervalId);

        this._intervalId = setInterval(() => {
            if (!this._window.closed) {
                return;
            }
            clearInterval(this._intervalId);
            reject(new Error('Authorization interrupted, window was closed before finishing the process'));
        }, this._closeInterval);
    }

    private _handleMessage(event: IEventMessage, resolve: (value: unknown) => void, accountLinkResponse: AccountLinkResponseDto, inputData?: Record<string, any>) {
        if (event.data?.type !== 'OAUTH_RESPOSE') {
            return;
        }
        this._window.close();
        window.removeEventListener('message', this._messageHandler as (event: IEventMessage) => void, false);

        return resolve({
            ...inputData,
            accountLinkResponse,
            oauthPayload: event.data.payload,
        });
    }

}

export default IntegratorOAuthHandler;
